import React from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import FadeIn from './FadeIn';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-24 bg-white relative overflow-hidden">
        {/* Decorative background blob */}
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-sand/40 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 translate-y-1/2 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-16">
          <FadeIn>
            <h2 className="font-display text-4xl md:text-5xl text-gray-900 mb-6">Begin Your Musical Journey</h2>
            <p className="text-gray-600 font-light text-lg mb-10">
              Whether you are a beginner taking your first step or an advanced student looking to refine your skills, we would love to hear from you.
            </p>

            <div className="space-y-8">
              <div className="flex items-start gap-4 group cursor-pointer">
                <div className="p-3 bg-ivory border border-gray-200 rounded-lg text-royal-maroon group-hover:bg-royal-maroon group-hover:text-white transition-colors">
                  <MapPin size={24} />
                </div>
                <div>
                  <h4 className="font-display text-xl text-gray-900 mb-1">Visit Us</h4>
                  <p className="text-gray-600 font-light">
                    12, Temple Street, Mylapore<br />
                    Chennai, Tamil Nadu 600004
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 group cursor-pointer">
                <div className="p-3 bg-ivory border border-gray-200 rounded-lg text-royal-maroon group-hover:bg-royal-maroon group-hover:text-white transition-colors">
                  <Mail size={24} />
                </div>
                <div>
                  <h4 className="font-display text-xl text-gray-900 mb-1">Email Us</h4>
                  <p className="text-gray-600 font-light">admissions@swaramacademy.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4 group cursor-pointer">
                <div className="p-3 bg-ivory border border-gray-200 rounded-lg text-royal-maroon group-hover:bg-royal-maroon group-hover:text-white transition-colors">
                  <Phone size={24} />
                </div>
                <div>
                  <h4 className="font-display text-xl text-gray-900 mb-1">Call Us</h4>
                  <p className="text-gray-600 font-light">+91 99588 90570</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={200} className="bg-ivory p-8 md:p-10 rounded-2xl border border-gray-100 shadow-xl shadow-royal-maroon/5">
            <h3 className="font-display text-2xl text-gray-900 mb-6">Send a Message</h3>
            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-wider text-gray-500 font-medium">Name</label>
                  <input type="text" className="w-full bg-white border border-gray-200 px-4 py-3 rounded focus:outline-none focus:border-royal-maroon focus:ring-1 focus:ring-royal-maroon transition-all" placeholder="Your Name" />
                </div>
                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-wider text-gray-500 font-medium">Phone</label>
                  <input type="tel" className="w-full bg-white border border-gray-200 px-4 py-3 rounded focus:outline-none focus:border-royal-maroon focus:ring-1 focus:ring-royal-maroon transition-all" placeholder="Your Number" />
                </div>
              </div>
              
              <div className="space-y-2">
                <label className="text-xs uppercase tracking-wider text-gray-500 font-medium">Email</label>
                <input type="email" className="w-full bg-white border border-gray-200 px-4 py-3 rounded focus:outline-none focus:border-royal-maroon focus:ring-1 focus:ring-royal-maroon transition-all" placeholder="your@email.com" />
              </div>

              <div className="space-y-2">
                <label className="text-xs uppercase tracking-wider text-gray-500 font-medium">Interest Level</label>
                <select className="w-full bg-white border border-gray-200 px-4 py-3 rounded focus:outline-none focus:border-royal-maroon focus:ring-1 focus:ring-royal-maroon transition-all text-gray-600">
                  <option>Beginner (Aarambha)</option>
                  <option>Intermediate (Madhyama)</option>
                  <option>Advanced (Nipuna)</option>
                </select>
              </div>

              <div className="space-y-2">
                <label className="text-xs uppercase tracking-wider text-gray-500 font-medium">Message</label>
                <textarea rows={4} className="w-full bg-white border border-gray-200 px-4 py-3 rounded focus:outline-none focus:border-royal-maroon focus:ring-1 focus:ring-royal-maroon transition-all" placeholder="Tell us about your musical background..."></textarea>
              </div>

              <button className="w-full py-4 bg-royal-maroon text-white rounded font-medium tracking-wide hover:bg-royal-maroon-light transition-colors shadow-lg shadow-royal-maroon/20 flex items-center justify-center gap-2 group">
                <span>Send Enquiry</span>
                <Send size={16} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </form>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Contact;